module.exports = __webpack_public_path__ + "img/india-taj-mahal.bac4cae0.jpg";